import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Typography, makeStyles,useTheme } from "@material-ui/core";
import iphone from "../../assets/images/iphone.png";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import MobileStepper from '@material-ui/core/MobileStepper';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const COLOR = "rgba(75, 123, 227, 1)";

const useStyles = makeStyles(theme => ({
  title: { color: "rgb 0 0 102", fontSize: "20px", paddingBottom: "20px", paddingTop: "30px", paddingLeft: "10px" },
  publish: { fontSize: "14px", lineHeight: "20px", paddingBottom: "30px", },
  box: { border: "2px solid gray", fontSize: "12px", padding: "1px 10px 1px 10px", borderRadius: "20%" },
  mobileTxt: { position: "absolute", top: "17%", left:'50%', width:'100%', height:'470px', padding:'30px', transform:'translate(-50%,-10%)', overflowX:'hidden', "&::-webkit-scrollbar":{ width:'12px' } },
  text3: { fontSize: "10px !important", padding: 28, textAlign: "justify" },
  giri:{ padding:0, overflow:'hidden', maxHeight:'100%' },
  gir2:{ overflow:'hidden', padding: "0 !important", background:'transparent' },
  createUser: {
    minWidth: "220px !important", textTransform: "", backgroundColor: COLOR,
    color: '#fff', borderRadius: "25px", border: "1px solid ", fontWeight: "500 !important",marginLeft:"-10px",
    '&:hover': { color: COLOR,  border: "1px solid #fff" },
    [theme.breakpoints.down("sm")]: {
        width: "120%",
        marginLeft:"-15px"
    }
  },
createUser1: {
    minWidth: "90px !important", textTransform: "uppercase", backgroundColor: COLOR, color: '#fff',
    borderRadius: "25px", border: "1px solid ", fontWeight: "500 !important",marginLeft:"-10px",paddingLeft: "20px",
    '&:hover': { color: COLOR,  border: "1px solid #fff" },
    [theme.breakpoints.down("sm")]: {
        width: "120%",
        marginLeft:"-15px"
    }
  },
text1:{color:"rgb( 0 0 102)!important",paddingTop:"22px",lineHeight:"41pt",letterSpacing:"-.041pt",paddingBottom: "15px",fontSize: "34px",fontWeight: 'bold',textAlign:"center"},
text2:{color:"rgb(142 142 147)!important",lineHeight:"25pt",letterSpacing:"-.035pt",paddingBottom: "15px",fontSize: "19px",fontWeight: 'bold',textAlign:"center"},
text4:{color:"rgb(0 0 0)!important",lineHeight:"17pt",letterSpacing:"-.045pt",paddingBottom: "15px",fontSize: "17px",fontWeight: 'bold'},
text5:{color:"rgb(0 0 0)!important",lineHeight:"17pt",letterSpacing:"-.045pt",paddingBottom: "15px",fontSize: "17px"},
header: { display: 'flex', alignItems: 'center', height: 50, paddingLeft: theme.spacing(4), backgroundColor: theme.palette.background.default, },
img: { maxHeight: 210, display: 'block', maxWidth: 400, overflow: 'hidden', width: '100%', },
}));

export default function DraggableDialog(props) {
  const [openstart, setOpenstart] = React.useState(true);
  const [screendata, setScreenData] = React.useState("");
  const [activeStep, setActiveStep] = React.useState(0);
let maxSteps;
    if( screendata){
     maxSteps = screendata.length;
    }
useEffect(()=>{
setScreenData(props.value.screen);
},[]);
const startscreen=()=>{
setOpenstart(false);
};
   const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const classes = useStyles();
 const theme = useTheme();
  return (
    <div>
      <Dialog classes={{paperScrollPaper:"paperScrollPaper"}} open={props.open} onClose={props.handleClose} maxWidth={"xs"}>
        <DialogContent className={classes.gir2} style={{ overflowX: 'hidden' }}>
          <div className={classes.mobile}>
            <img src={iphone} width="100%" />
            <div className={classes.mobileTxt}>
               <Typography style={{paddingBottom:"10px",textAlign:"center"}}>Title</Typography>
                 {openstart?
                  <GridContainer>
                  <GridItem md={12} lg={12} sm={12} xs={12} >
                {props.value.chapterimage.base64Rep?<img src={props.value.chapterimage.base64Rep} width="100%"/>:<img src={props.value.chapterimage} width="100%"/>}
                   </GridItem>
                  <GridItem md={12} lg={12} sm={12} xs={12}>
                <Typography className={classes.text1}>{`Chapter ${props.value.chapterid}`}</Typography></GridItem>
                <GridItem md={12} lg={12} sm={12} xs={12} >
                <Typography className={classes.text2}>{props.value.title}</Typography></GridItem>
                  <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                 <br/><br/>
                <Button className={classes.createUser} onClick={()=>startscreen()}>Get Started</Button></GridItem>
               </GridContainer>
                :<>

                 <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
      >
        {screendata.map((step, index) => (
          <div key={index}>
            {Math.abs(activeStep - index) <= 2 ? (
               step.image.base64Rep?<img className={classes.img} src={step.image.base64Rep} alt={step.label} />:<img className={classes.img} src={step.image} alt={step.label} />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
         <GridContainer>
          <GridItem md={12} lg={12} sm={12} xs={12} >
        <Typography  className={classes.text4}>{screendata[activeStep].title}</Typography></GridItem>
           <GridItem md={12} lg={12} sm={12} xs={12} >
            <div dangerouslySetInnerHTML={{ __html:screendata[activeStep].description}} className={classes.text5} style={{paddingBottom: "10px" }} />
</GridItem>
         </GridContainer>
<br/><br/>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="dots"
        activeStep={activeStep}
        nextButton={
           activeStep === maxSteps - 1? <Button size="small" className={classes.createUser1} style={{width:"100px!important",paddingLeft:"5px "}} onClick={props.handleClose}>
            Close
          </Button>:
          <Button size="small" className={classes.createUser1} style={{width:"100px!important"}} onClick={handleNext}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
      />

                </>}
            </div>
          </div>

        </DialogContent>

      </Dialog>
    </div>
  );
}
